module.exports = __webpack_public_path__ + "images/pointer_23882d8feec38924d237329313ee8f352.svg";